var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.preview)?_c('div',{staticClass:"back-to-assignment-bank"},[_c('b-button',{staticClass:"btn-back-to-overview btn-back",attrs:{"variant":"outline-primary"},on:{"click":_vm.previewStatusUpdate}},[_vm._v("\n        "+_vm._s(_vm.$t('databank.back_to_overview'))+"\n    ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }